<div *ngIf="fieldsSetting !== null && fieldsSetting !== undefined" class="details-section">
  <div *ngIf="!isEditMode" class="header d-flex justify-content-start align-items-center">
    <h3 class="fontsize22">2. {{ 'view_translations.complete_the_details' | translate }}</h3>
  </div>
  <app-social-media *ngIf="isSocialMedia" [socialMediaTypes]="fieldsSetting.children" (selectedSocialMedia)="onSelectSocialMedia($event)"> </app-social-media>
  <div class="profile-select" *ngIf="profilTypeSelect.length > 0 && addProfileTypeSelect">
    <app-select-container
      *ngFor="let type of profilTypeSelect"
      [data]="type.data"
      [title]="type.title"
      [submitted]="submitted"
      (emitValue)="onChangeProfileType($event)"
      [shouldTranslate]="false">
    </app-select-container>
  </div>
  <div *ngIf="currentDetailsMode === 'trafficSourceDetails'">
    <div class="form-content" *ngFor="let field of fieldsInfo; index as i">
      <div class="checkbox-input-container" *ngIf="field.system_name === 'is_adult'">
        <ng-container [ngTemplateOutlet]="adultCheckbox"></ng-container>
      </div>
      <div class="text-input" id="textInput">
        <app-text-input
          *ngIf="field.system_name === 'url' || field.system_name === 'name'|| field.system_name === 'views' || field.system_name === 'database_size' || field.system_name === 'download'
                    || field.system_name === 'publishers' || field.system_name === 'followers' || field.system_name === 'subscriptions'
                    || field.system_name === 'karma_number' || field.system_name === 'likes' || field.system_name === 'post_number'
                    || field.system_name === 'relations_number' || field.system_name === 'group_channel_number' || field.system_name === 'channel_number'
                    || field.system_name === 'members_biggest_channel' || field.system_name === 'friends' || field.system_name === 'people_connected'
                    || field.system_name === 'group_number' || field.system_name === 'members_biggest_group' || field.system_name === 'members'"
          [ngClass]="{'d-none' : (field.required === false && additionalInformation === false )}"
          [fieldInfo]="field"
          [submitted]="submitted"
          (emitValue)="getValue($event, 'input')"
          [configurationData]="textInputConfigData[field.system_name]"
          [validators]="checkValidators(field.system_name)"
          [inputName]="setInputName(field.system_name === 'name' ? 'code_name' : field.system_name)"
          [showAutofocus]="i === 0">
        </app-text-input>
        <small *ngIf="isEditMode && field.system_name === 'url'" class="form-text verification-info">
          {{ 'view_translations.re_verifciation_info' | translate }}
        </small>
      </div>
      <div *ngIf="i === (fieldsInfo.length - 2)">
        <div class="select-container" *ngFor="let select of selectContainers">
          <app-select-container
            [ngClass]="{'d-none' : (select.required === false && additionalInformation === false )}"
            [data]="select.data"
            [title]="select.title"
            [submitted]="submitted"
            (emitValue)="getValue($event, 'select')"
            [shouldTranslate]="false"
            [idOfDefaultValue]="fieldsToSend[select.title]">
          </app-select-container>
          <app-text-input
            *ngIf="fieldsToSend['ad_platform'] == 2"
            [fieldInfo]="{ system_name: 'ad_platform_other', type: 'textInput' }"
            [submitted]="submitted"
            (emitValue)="getValue($event, 'input')"
            [configurationData]="textInputConfigData['ad_platform_other']"
            [validators]="checkValidators('ad_platform_other')"
            [inputName]="setInputName('ad_platform_other')"
            [showAutofocus]="i === 0">
          </app-text-input>
        </div>
      </div>
      <div id="destinationGroupCountries" [ngClass]="{'d-none' : (field.required === false && additionalInformation === false )}">
        <app-countries-checkbox-list
          *ngIf="field.system_name === 'destination_group_countries'"
          [ngClass]="{'d-none' : (field.required === false && additionalInformation === false )}"
          [countries]="countriesArray"
          [layout]="'traffic_source'"
          [required]="field.required"
          [submitted]="submitted"
          [initValues]="countriesInitValues"
          (emitCheckedCountries)="getCheckedCountries($event)">
        </app-countries-checkbox-list>
      </div>
      <app-traffic-source-categories
        id="categories"
        *ngIf="field.system_name === 'categories'"
        [ngClass]="{'d-none' : (field.required === false && additionalInformation === false )}"
        [categoriesValuesArray]="categoriesArray"
        [submitted]="submitted"
        (checkedValues)="getCategoriesValue($event)"
        [isEditMode]="isEditMode">
      </app-traffic-source-categories>
      <app-textarea-input
        id="textarea"
        *ngIf="field.system_name === 'description'"
        [ngClass]="{'d-none' : (field.required === false && additionalInformation === false )}"
        [configurationData]="textInputConfigData[field.system_name]"
        [fieldInfo]="field"
        [inputName]="field.system_name"
        [placeholder]="'input_label'"
        [submitted]="false"
        (emitValue)="getValue($event, 'textarea')">
      </app-textarea-input>
      <!--      <ng-container *ngIf="i === (fieldsInfo.length - 1)  && showAdditionalFieldsControl && !additionalInformation || (additionalInformation && i === 3)">-->
      <ng-container
        *ngIf="fieldsSetting.id != 7 && fieldsSetting.id != 34 && (i === (fieldsInfo.length - 1)  && !additionalInformation || (additionalInformation && i === 3))">
        <!--        why was it a part of this conditionally shown code ?-->
        <!--        <div *ngIf="additionalInformation" class="checkbox-input-container">-->
        <!--          <ng-container [ngTemplateOutlet]="adultCheckbox"></ng-container>-->
        <!--        </div>-->
        <div class="radio-container global-transition">
          <h3 class="fontsize16 font700">{{ 'view_translations.additional_information_question' | translate}}</h3>
          <div class="radio-button-container">
            <label class="container"
              >{{ 'view_translations.yes' | translate}}
              <input type="radio" [value]="true" name="additionalInformation" [(ngModel)]="additionalInformation" (change)="getAdditionalInfoValue(true)" />
              <span class="checkmark"></span>
            </label>
            <label class="container"
              >{{ 'view_translations.no' | translate}}
              <input type="radio" [value]="false" name="additionalInformation" [(ngModel)]="additionalInformation" (change)="getAdditionalInfoValue(false)" />
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<div *ngIf="fieldsInfo.length > 0">
  <hr class="separator" *ngIf="currentDetailsMode === 'trafficSourceDetails'" />
  <div *ngIf="currentDetailsMode === 'trafficSourceDetails'">
    <div class="footer d-flex align-items-center">
      <app-primary-button [buttonText]="submitBtnText" [icon]="''" [iconSize]="12" [background]="'orange'" (click)="verifyForm()"> </app-primary-button>
    </div>
  </div>
</div>

<ng-template #adultCheckbox>
  <label class="is-adult-checkbox">
    <input type="checkbox" name="isAdult" [ngModel]="isAdultCheckboxValue" (change)="onChangeIsAdultCheckboxValue()" />
    <div class="element-text global-transition">
      {{'view_translations.adult_content' | translate}}
      <div class="info-icon">
        <p>
          <nb-icon
            icon="info"
            pack="icomoon"
            placement="top-right"
            ngbTooltip="{{ 'adult_content_included' | t }}"
            container="body"
            tooltipClass="my-configurations-tooltip"></nb-icon>
        </p>
      </div>
    </div>
    <span class="checkmark"></span>
  </label>
</ng-template>
